;(function() {
  'use strict'

  Service.$inject = ["$q", "searchService", "pagesResource"];
  angular.module('core.services').factory('zonePageService', Service)

  /* @ngInject */
  function Service($q, searchService, pagesResource) {
    // This service uses Pages to simulate what a Zones resource would return.
    // 1. Search for hashtags using the Zone theme name as the hastag text
    // 2. If found, pull out the pageId
    // 3. Get that page
    // 4. Map the page properties to Zone "server" data

    return {
      getTheme: getTheme,
    }

    function getTheme(themeName) {
      return $q(function(resolve, reject) {
        return getPageIdByThemeName(themeName)
          .then(function(pageId) {
            if (!pageId) {
              return reject({ response: 'Not found', status: 404 })
            }

            pagesResource
              .get({ id: pageId })
              .success(function(x, page) {
                resolve(mapPageToTheme(page))
              })
              .error(function(response, status) {
                reject({ response: response, status: status })
              })
          })
          .catch(reject)
      })
    }

    function getPageIdByThemeName(themeName) {
      return $q(function(resolve, reject) {
        var hashtagText = themeName
        var hashTag = '#' + hashtagText
        return searchService
          .search(hashTag, { type: searchService.Types.PAGE })
          .then(function(results) {
            var match = _.find(results, function(result) {
              return (
                result.type === 'page' &&
                _.includes(result.hashTags, hashtagText.toLowerCase())
              )
            })

            if (!match) {
              reject({ response: 'Not found', status: 404 })
            } else {
              resolve(match.pageId)
            }
          })
      })
    }

    function mapPageToTheme(page) {
      return {
        title: page.title,
        tagline: page.subTitle,
        imageUrl: page.logoUrl,
      }
    }
  }
})()
